<form #modal [formGroup]="form">
    <div class="modal-header">
        <h2 class="headline m-0" fxFlex="auto">Pay with Benefit</h2>
        <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
        </button>
    </div>

    <div class="modal-body">
        <qrcode [qrdata]="qrData" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
        <div class="form-group required">
            <label class="control-label" >Upload recipet</label>
            <input class="form-control" type="file" (change)="fileBrowseHandler($event.target.files)"  required/>
           
        </div>
    </div>

    <div class="modal-footer">
        <button mat-flat-button (click)="bsModalRef.hide()" type="button">
            Cancel
        </button>
        <button mat-flat-button type="button" color="primary" (click)="save()">Submit</button>
    </div>
</form>